import { render } from "./WaitBoardCard.vue?vue&type=template&id=634f2ff0&scoped=true&ts=true"
import script from "./WaitBoardCard.vue?vue&type=script&lang=ts"
export * from "./WaitBoardCard.vue?vue&type=script&lang=ts"

import "./WaitBoardCard.vue?vue&type=style&index=0&id=634f2ff0&lang=less&scoped=true"

import exportComponent from "/root/djmesweb-pc/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-634f2ff0"]])

export default __exports__